<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <!-- <button @click="logReport">log report</button> -->
    <b-card class="advanced-reports">
      <h4 class="mb-1">اختر جدولاً</h4>
      <div class="d-flex w-100 flex-wrap">
        <b-badge
          v-for="(table, i) in tables"
          :key="i"
          :id="table.value"
          :class="selected === table.value ? 'badge-glow' : ''"
          :variant="selected === table.value ? 'primary' : 'light-primary'"
          class="table-chip"
          style=""
          @click="selectTable(table.class, table.value)"
          >{{ table.text }}</b-badge
        >
      </div>

      <hr />
      <b-row class="my-1" v-if="selected">
        <b-col xl="6" lg="6" md="6">
          <h4>اختر الحقول</h4>
          <div class="my-1">
            <b-badge
              :class="!isFilterSelected ? 'badge-glow' : ''"
              :variant="!isFilterSelected ? 'primary' : 'light-primary'"
              class="table-chip"
              @click="isFilterSelected = false"
              >الحقول</b-badge
            >
            <b-badge
              :class="isFilterSelected ? 'badge-glow' : ''"
              :variant="isFilterSelected ? 'danger' : 'light-danger'"
              class="table-chip mx-50"
              @click="isFilterSelected = true"
              >الفلاتر</b-badge
            >
          </div>
          <search-input
            placeholder="أدخل اسم الحقل أو جزء منه ..."
            v-model="search"
            class="w-75 mx-auto"
          />
          <div
            style="height: 40vh; overflow: auto"
            class="px-50"
            :key="selected"
          >
            <fields-list
              v-show="isFilterSelected"
              :title="selected"
              :fields="filteredFields"
              :filters="selectedFilters"
              :objKey="selected"
              :dataPath="selected"
              :isFilter="true"
              @fieldChecked="filtersKey++"
              key="1"
            />
            <fields-list
              v-show="!isFilterSelected"
              :title="selected"
              :fields="filteredFields"
              :objKey="selected"
              :dataPath="selected"
              key="2"
            />
          </div>
        </b-col>

        <b-col style="height: 50vh; overflow: auto">
          <h4>الفلاتر</h4>
          <advanced-reports-filters-renderer
            v-model="filters"
            :key="filtersKey"
            :formSchema="filtersSchema"
          />
        </b-col>

        <b-col class="pt-1 justify-content-center" cols="1">
          <loader-btn
            block
            label="إنشاء"
            icon="PlusIcon"
            class="mx-auto"
            variant="success"
            :loading="loading"
            loadingLabel="جارٍ المعالجة..."
            @click="fetchQuery"
          ></loader-btn>
          <loader-btn
            :loading="saving"
            block
            class="my-1"
            variant="info"
            @click="onSaveClicked"
          >
          </loader-btn>
          <b-button
            :disabled="result && result.length === 0"
            block
            @click="exportTable"
            variant="outline-warning"
          >
            <feather-icon class="mr-25" icon="DownloadIcon" />
            تصدير
          </b-button>
          <b-button
            block
            class="my-1"
            style="gap: 5px"
            variant="outline-primary"
            @click="historyModal = true"
          >
            <feather-icon icon="ClockIcon" />
            السجل
          </b-button>
          <b-button
            block
            class="my-1"
            style="gap: 5px"
            variant="outline-success"
            @click="refresh"
          >
            <feather-icon class="mr-25" icon="RefreshCwIcon" />
            جديد
          </b-button>
        </b-col>
      </b-row>
      <form-modal
        v-model="saveQueryModal"
        title="حفظ التقرير"
        :formSchema="saveQuerySchema"
        @confirm="onConfirmSaveQuery"
        :loading="saving"
      />

      <saved-queries-modal
        v-if="historyModal"
        @querySelected="resolveQuery"
        v-model="historyModal"
        :key="historyKey"
      />
      <graphql-data-table
        @loading="setLoading($event)"
        @result="handleRes"
        v-if="gqlQuery.length > 0"
        :key="gqlQuery"
        :query="gqlQuery"
        :fields="savedFields"
        id="graphql_data_table"
      />
    </b-card>
  </div>
</template>

<script>
import SearchInput from "@/components/SearchInput.vue";
import {
  BCard,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BListGroup,
  BListGroupItem,
  BBadge,
} from "bootstrap-vue";
import AdvancedReportsFiltersRenderer from "../../components/AdvancedReportsFiltersRenderer.vue";
import MinistryBreadcrumbs from "../../components/MinistryBreadcrumbs.vue";
import graphqlDataTable from "@/components/graphql-data-table";
import { jsonToGraphQLQuery } from "json-to-graphql-query";
import { graphQlQueryToJson } from "graphql-query-to-json";
import FormModal from "@/components/FormModal.vue";
import FieldsList from "../../components/FieldsList.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import * as models from "@/schema/schema.js";
import tables from "./tables";
import LoaderBtn from "@/components/loader-btn.vue";
import SavedQueriesModal from "../../components/SavedQueriesModal.vue";
import unset from "lodash.unset";
import * as XLSX from 'xlsx';  

export default {
  components: {
    MinistryBreadcrumbs,
    BCard,
    BButton,
    BFormGroup,
    BFormRadioGroup,
    BListGroup,
    BListGroupItem,
    BFormCheckboxGroup,
    BFormCheckbox,
    BRow,
    BCol,
    BBadge,
    AdvancedReportsFiltersRenderer,
    graphqlDataTable,
    FormModal,
    FieldsList,
    LoaderBtn,
    SavedQueriesModal,
    SearchInput,
  },
  data() {
    return {
      search: null,
      historyModal: false,
      saveQueryModal: false,
      gqlQuery: "",
      query: {},
      toExpand: [],
      nextKeysPath: [],
      selectedMappedKeys: [],
      tables,
      isFilterSelected: false,
      filtersKey: 0,
      filtersValue: {},
      selected: null,
      selectedFields: [],
      selectedFilters: {},
      filters: {},
      result: [],
//       fields : [
//     {
//         'key': 'id'
//     },
//     {
//         'key': 'name_ar'
//     },
//     {
//         'key': 'bankAccounts.id'
//     },
//     {
//         'key': 'bankAccounts.branch_name'
//     },
//     {
//         'key': 'bankAccounts.accountManagers.id'
//     },
//     {
//         'key': 'bankAccounts.accountManagers.full_name'
//     }
// ],
      historyKey: 0,
      saveQuerySchema: {
        name: {
          key: "name",
          component: "FormInput",
          attrs: {
            label: "اسم التقرير",
            rules: "required",
          },
        },
      },

      mainTitle: "إنشاء تقرير متقدم",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "التقارير",
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("AdvancedReports", [
      "reportQuery",
      "filtersSchema",
      "queryFilters",
      "loading",
      "saving",
      "size",
      "page",
      "savedFields",
    ]),
    filteredFields() {
      return this.search
        ? this.selectedFields.filter((e) =>
            this.$t(e.key).includes(this.search)
          )
        : this.selectedFields;
    },
  },
  methods: {
    ...mapMutations("AdvancedReports", [
      "clearFilterSchema",
      "clearQuery",
      "setQuery",
      "setLoading",
    ]),
    ...mapActions("AdvancedReports", ["saveReport"]),
    ...mapActions("Exporter", ["exportGqlToExcel"]),
    ...mapMutations("Exporter", ["setGqlQueryToExport"]),
    // logReport() {
    //   console.log(graphQlQueryToJson(""));
    // },
    async onConfirmSaveQuery(form) {
      await this.saveReport(form.name);
      this.historyKey++;
      this.saveQueryModal = false;
    },
    onSaveClicked() {
      this.saveQueryModal = true;
    },
    resolveQuery(e) {
      var getJson = graphQlQueryToJson(`query { ${e.query} }`);

      var tableToSelect = document.getElementById(
        Object.keys(getJson.query)[0]
      );
      if (this.selected !== Object.keys(getJson.query)[0])
        tableToSelect.click();
      var keys = getJson.query[Object.keys(getJson.query)[0]];
      this.checkboxCheckCrawl(keys);

      this.historyModal = false;
    },
    async checkboxCheckCrawl(keys, keysPath) {
      this.toExpand = [];
      var prefexId = "";
      if (keysPath) prefexId = `#${keysPath} `;

      this.nextKeysPath = [];
      await this.$nextTick(() => {
        for (const key in keys) {
          if (Object.hasOwnProperty.call(keys, key)) {
            const val = keys[key];
            var toInput = document.querySelector(`${prefexId}#${key} input`);
            toInput.click();
            toInput.checked = true;
            toInput.setAttribute("checked", "true");
            if (typeof val === "object") {
              this.toExpand.push(val);
              this.nextKeysPath.push(key);
            }
          }
        }
      });
      setTimeout(() => {
        this.toExpand.forEach((e, i) => {
          this.checkboxCheckCrawl(e, this.nextKeysPath[i]);
        });
      }, 0);
    },
    handleRes(e) {
      this.result = e.data[this.selected];
      console.log("this.result" , this.result) 
      this.historyKey++;
    },
    exportTable() {
      // this.exportGqlToExcel();
      // this.fetchQuery()
      this.exportToExcel()
    },

    fetchQuery() {
      if (!this.reportQuery[this.selected]) {
        this.$toast.warning("يرجى اختيار حقل على الأقل");
        return;
      }
      var firstValue;

      if (typeof this.size === 'string') {
          firstValue = 1000000;
      } else {
          firstValue = this.size;
      }
      var queryOptions = { first: firstValue, page: this.page };

      // var queryOptions = {};

      if (Object.keys(this.queryFilters).length > 0)
        queryOptions.filter = this.queryFilters[this.selected];

      var mapped = {};
      if (this.selected) {
        mapped[this.selected] = {
          __args: queryOptions,
          data: { ...this.reportQuery[this.selected] },
          paginatorInfo: {
            count: true,
            currentPage: true,
            firstItem: true,
            hasMorePages: true,
            lastItem: true,
            lastPage: true,
            perPage: true,
            total: true,
          },
        };
      }
      unset(mapped, `${this.selected}.data.__args`);
      this.setQuery(mapped);
      const parsed = jsonToGraphQLQuery({ query: mapped }, { pretty: true });
      var rawQuery = { ...mapped };
      unset(rawQuery, `${this.selected}.paginatorInfo`);
      this.setGqlQueryToExport(rawQuery);
      rawQuery = jsonToGraphQLQuery({ query: rawQuery }, { pretty: true });
      this.gqlQuery = parsed;
    },
    selectTable(className, value) {
      if (this.selected) {
        delete this.query[value];
        this.clearFilterSchema();
        this.filters = {};
        if (this.selected !== value) {
          this.selected = value;
          this.query[value] = {};
        } else {
          this.selected = null;
        }
      } else {
        this.selected = value;
        this.query[value] = {};
      }
      this.selectedFields = new models[className]().getProps(true);
      this.selectedFilters = new models[className]().inputs;
      this.isFilterSelected = false;
    },
    refresh() {
      const originalData = JSON.parse(JSON.stringify(this.$options.data()));
      Object.assign(this.$data, originalData);
      this.clearQuery();
      this.clearFilterSchema();
      this.gqlQuery = "";
    },
    exportToExcel() {  
      const fileName = 'exported_data.xlsx';  
      const wb = XLSX.utils.book_new();  
      const ws = XLSX.utils.table_to_sheet(document.getElementById('graphql_data_table'));  
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');  
      XLSX.writeFile(wb, fileName);  
    } 
  },
  watch: {
    size() {
      this.fetchQuery();
    },
    page() {
      this.fetchQuery();
    },
    reportQuery: {
      deep: true,
      handler(val) {
        this.gqlQuery = val;
      },
    },
  },

  mounted() {
    this.selectTable("Ngo", "ngos");
  },
};
</script>

<style lang="scss">
.table-chip {
  font-size: small;
  padding: 10px 20px;
  margin: 5px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
}
.advanced-reports {
  .btn-group {
    .grid-container {
      display: grid;
      grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto;
    }
  }
}
</style>
